import { CRUD } from "@/shared/components";
import {
  ContractsListQuery,
  type ContractsListRow,
} from "@/admin/entities/contracts";
import { BillingContractsConfig, BillingContractsSchemas } from "../model";

/**
 * Контракты всех организаций одним списком, полный CRUD: создание,
 * редактирование, отмена (спека, раздел «Контракты»). Раньше это была
 * вкладка внутри карточки организации, теперь отдельный раздел меню.
 */
export function BillingContracts() {
  return (
    <CRUD<ContractsListRow>
      listQuery={ContractsListQuery}
      getTableData={BillingContractsConfig.getTableData}
      mapColumns={BillingContractsConfig.mapColumns}
      columns={BillingContractsConfig.getColumnsConfig()}
      filterSchema={BillingContractsSchemas.filterSchema}
      normalizeFilter={BillingContractsSchemas.normalizeFilter}
      createSchema={BillingContractsSchemas.createSchema}
      createInitialVariables={
        BillingContractsSchemas.createContractInitialVariables as Partial<ContractsListRow>
      }
      editSchema={BillingContractsSchemas.editSchema}
      texts={BillingContractsConfig.getTextsConfig()}
      persistFilters
      useMobileView
      mobileColumns={BillingContractsConfig.getMobileColumnsConfig()}
    />
  );
}
